import { useTranslations } from 'next-intl';

import { ducatCircle as IconDucatCircle } from '@/components/icons/ducatCircle';

import { getPageNameKey } from '../utils';

interface LabelProps {
  pathname: string;
}

const Label: React.FC<LabelProps> = ({ pathname }: LabelProps) => {
  const t = useTranslations('layout');

  return (
    <div className="flex min-w-0 items-center gap-2">
      <IconDucatCircle className="shrink-0" />
      <p title={t(getPageNameKey(pathname))} className="hidden xs:block min-w-0 truncate text-xl font-medium text-text-primary">
        {t(getPageNameKey(pathname))}
      </p>
    </div>
  );
};

export default Label;
